import Component from "../../lib/component";
import {DropdownNav} from "./dropdown_nav";
import {DropdownBtn} from "./dropdown_btn";

export const DropdownConfig = {
    componentTypeKey: 'Dropdown',
    baseHtmlClass: 'dropdown',
    selector: '.dropdown',

    datasetConfigKey: 'dropdown__config',
};

export class Dropdown extends Component {

    static get config() {
        return DropdownConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: Dropdown.config
        });

        this.setDatasetConfig(Dropdown.config.datasetConfigKey);

        this.dropdownBtn = this.getDropdownBtn();
        this.dropdownNav = getDropdownNav(this);

        document.addEventListener('click', this.handleDocumentClick.bind(this));

        this.open = false;
        this.element.style.display = null;
        this.render();
    }

    render() {
        this.swapHtmlClassStates(this.isOpen(), 'open', 'closed');
        this.dropdownBtn.render();
        this.dropdownNav.render();
    }

    isOpen() {
        return this.open;
    }

    toggle() {
        this.open = !this.isOpen();
    }

    close() {
        this.open = false;
    }

    handleDocumentClick(event) {
        if (!this.isOpen()) return;
        if (this.dropdownBtn.element.contains(event.target)) return;
        if (this.dropdownNav.element.contains(event.target)) return;
        event.preventDefault();
        this.close();
        this.render();
    }

    getDropdownBtn() {
        let element = null;
        const id = this.getDatasetConfigValue('btn_id');
        if (id) element = document.getElementById(id);
        if (!element) console.warn(`[Dropdown] No btn element found with ID of ${id}:`, this);
        return new DropdownBtn(element, this);
    }

}

function getDropdownNav(dropdown) {
    const element = dropdown.element.querySelector(DropdownNav.config.selector);
    return new DropdownNav(element, dropdown);
}

